import * as graphql from 'generated/graphql';
import _ from 'lodash';
import { currencyAndDecimalFieldPolicy } from './fieldPolicies';
import { ITypeSpecificPolicy } from './shared';



export const Price: ITypeSpecificPolicy<graphql.Price> = {
  fields: {
    amount: currencyAndDecimalFieldPolicy(),

    formattedUnitInterval: {
      read: (existing, { readField }) => {
        const interval = readField<graphql.BillingPeriod>('interval');
        const intervalCount = readField<number>('intervalCount');

        return `seat/${intervalCount === 1 ? '' : (intervalCount + ' ')}${__getIntervalAbbrev(interval)}`;
      }
    },


    tiers: {
      read: (existing, { readField }) => {
        const tiers: graphql.PriceTier[] = existing;

        if (!tiers) {
          return existing;
        }

        return _.uniqBy(tiers, (t) => t.unitAmount);
      }
    }
  }
};



function __getIntervalAbbrev(interval?: graphql.BillingPeriod) {
  switch (interval) {
    case 'daily': return 'dy';
    case 'monthly': return 'mo';
    case 'yearly': return 'yr';
  }
}

